export class LimbusErrorResponse {

    constructor(public status: LimbusErrorStatus,
        public messages: ResponseMessage[],
        public generalInfo: string[]) {
    }
}

export class LimbusErrorStatus {

    constructor(public value: number,
        public name: string) {
    }
}

export class ResponseMessage {

    constructor(public reference: string,
        public message: string) {
    }
}
